"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortAxes = exports.getMaxAxe = exports.getMinAxe = exports.getAxeScore = void 0;
const tier_1 = require("./tier");
function getAxeScore(dna) {
    let score = 0;
    const tier = (0, tier_1.getAxeTier)(dna);
    const benefits = dna.slice(1);
    for (var i = 0; i < benefits.length; i++) {
        let benefit = Number(benefits[i]) + tier;
        score += benefit;
    }
    return score;
}
exports.getAxeScore = getAxeScore;
function getMinAxe(...dnas) {
    const [min] = sortAxes(dnas);
    return min;
}
exports.getMinAxe = getMinAxe;
function getMaxAxe(...dnas) {
    const [max] = sortAxes(dnas, -1);
    return max;
}
exports.getMaxAxe = getMaxAxe;
function sortAxes(dnas, order = 1) {
    return dnas
        .filter(v => v)
        .map((dna) => ({ dna, score: getAxeScore(dna) }))
        .sort((a, b) => (a.score - b.score) * order)
        .map(a => a.dna);
}
exports.sortAxes = sortAxes;
//# sourceMappingURL=score.js.map